const storeTypes = {
  PARTNER_AS_POA:"PARTNER_AS_POA CARE",
  SET_EXECUTOR:'SET POA_CARE EXECUTOR',
  SET_COEXECUTOR:'SET POA_CARE CO_EXECUTOR',
  SET_ALT_EXECUTOR:'SET POA_CARE ALT EXECUTOR',
}
export default storeTypes;